/* eslint max-len: 0 */
const pageStatistics = {
  CALENDAR_ATTACHMENTS: 'CALENDAR_ATTACHMENTS',
  CHANGE_EMAIL_AND_PASSWORD: 'CHANGE_EMAIL_AND_PASSWORD',
  COOKIES: 'COOKIES',
  CUSTOMER_HAS_PASSWORD: 'CUSTOMER_HAS_PASSWORD',
  NUMBER_OF_ADDRESSES: 'NUMBER_OF_ADDRESSES',
  ADDRESS_OUT_OF_ZONE: 'ADDRESS_OUT_OF_ZONE',
  ADDRESS_NICKNAME_FILLED: 'ADDRESS_NICKNAME_FILLED',
  ADDRESS_POSTCODE_FILLED: 'ADDRESS_POSTCODE_FILLED',
  DELIVERY_INSTRUCTIONS_FILLED: 'DELIVERY_INSTRUCTIONS_FILLED',
  ADDRESS_COMPANY_NAME_FILLED: 'ADDRESS_COMPANY_NAME_FILLED',
  ADDRESS_PREFECTURE_FILLED: 'ADDRESS_PREFECTURE_FILLED',
  ADDRESS_STREET_TRANSCRIPTION_FILLED: 'ADDRESS_STREET_TRANSCRIPTION_FILLED',
  ADDRESS_NUMBER_FILLED: 'ADDRESS_NUMBER_FILLED',
  ADDRESS_STREET_FILLED: 'ADDRESS_STREET_FILLED',
  ADDRESS_STREET2_FILLED: 'ADDRESS_STREET2_FILLED',
  ADDRESS_CITY_FILLED: 'ADDRESS_CITY_FILLED',
  ADDRESS_PROVINCE_FILLED: 'ADDRESS_PROVINCE_FILLED',
  ADDRESS_DELIVERY_DETAILS_FILLED: 'ADDRESS_DELIVERY_DETAILS_FILLED',
  ADDRESS_ENTERED_MANUALLY: 'ADDRESS_ENTERED_MANUALLY',
  NUMBER_OF_USED_PAYMENT_TOKENS: 'NUMBER_OF_USED_PAYMENT_TOKENS',
  NUMBER_OF_NOT_USED_PAYMENT_TOKENS: 'NUMBER_OF_NOT_USED_PAYMENT_TOKENS',
  ADDRESS_COUNTY_FILLED: 'ADDRESS_COUNTY_FILLED',
};

const pageEvents = {
  CALENDAR_EVENTS_CALENDAR_ATTACHMENTS_VALUE_CHANGED: 'Customer changed calendar attachments settings',
  CALENDAR_EVENTS_SAVE_BUTTON_CLICKED: 'Save button clicked',
  CALENDAR_EVENTS_SUCCESS_NOTIFICATION_DISPLAYED: 'Success notification displayed after saving calendar events preferences',
  CALENDAR_EVENTS_ERROR_NOTIFICATION_DISPLAYED: 'Error notification displayed after saving calendar events preferences',

  CHANGE_CREDENTIALS_SAVE_EMAIL_SUCCESS_NOTIFICATION_DISPLAYED: 'Success notification displayed after saving email address',
  CHANGE_CREDENTIALS_SAVE_EMAIL_ERROR_NOTIFICATION_DISPLAYED: 'Error notification displayed after saving email address',
  CHANGE_CREDENTIALS_SAVE_PASSWORD_SUCCESS_NOTIFICATION_DISPLAYED: 'Success notification displayed after saving password',
  CHANGE_CREDENTIALS_SAVE_PASSWORD_ERROR_NOTIFICATION_DISPLAYED: 'Error notification displayed after saving password',
  CHANGE_CREDENTIALS_SAVE_PASSWORD_BUTTON_CLICKED: 'Save changes button was clicked on change password form',
  CHANGE_CREDENTIALS_SAVE_EMAIL_BUTTON_CLICKED: 'Save changes button was clicked on change email form',

  COOKIE_CONSENT_CHANGED: 'Customer changed cookie consent',

  DELIVERY_ADDRESS_BOOK_ADD_NEW_ADDRESS_CLICKED: 'Add new address clicked',
  DELIVERY_ADDRESS_BOOK_EDIT_ADDRESS_CLICKED: 'Edit address clicked',
  DELIVERY_ADDRESS_BOOK_OVERRIDE_ADDRESS_CLICKED: 'Override address clicked',

  DELIVERY_ADDRESS_BOOK_ADD_ADDRESS_POSTCODE_VALID: 'Find address clicked (postcode valid)',
  DELIVERY_ADDRESS_BOOK_ADD_ADDRESS_FROM_THE_LIST: 'Customer chose address from list',
  DELIVERY_ADDRESS_BOOK_ADD_ADDRESS_SAVE_BUTTON_CLICKED: 'Save button clicked',
  DELIVERY_ADDRESS_BOOK_ADD_ADDRESS_SUCCESS_NOTIFICATION_DISPLAYED: 'Success notification displayed after saving new address',
  DELIVERY_ADDRESS_BOOK_ADD_ADDRESS_ERROR_NOTIFICATION_DISPLAYED: 'Error notification displayed after saving new address',

  DELIVERY_ADDRESS_BOOK_EDIT_ADDRESS_SAVE_BUTTON_CLICKED: 'Save button clicked',
  DELIVERY_ADDRESS_BOOK_EDIT_ADDRESS_SUCCESS_NOTIFICATION_DISPLAYED: 'Success notification displayed after saving edit address',
  DELIVERY_ADDRESS_BOOK_EDIT_ADDRESS_ERROR_NOTIFICATION_DISPLAYED: 'Error notification displayed after saving edit address',

  DELIVERY_ADDRESS_BOOK_OVERRIDE_ADDRESS_SAVE_BUTTON_CLICKED: 'Save button clicked',
  DELIVERY_ADDRESS_BOOK_OVERRIDE_ADDRESS_SUCCESS_NOTIFICATION_DISPLAYED: 'Success notification displayed after saving overridden address',
  DELIVERY_ADDRESS_BOOK_OVERRIDE_ADDRESS_ERROR_NOTIFICATION_DISPLAYED: 'Error notification displayed after saving overridden address',
  DELIVERY_ADDRESS_BOOK_OVERRIDE_ADDRESS_OUT_OF_DELIVERY_AREA_NOTIFICATION_DISPLAYED: 'Error notification displayed after saving overridden address -' +
  ' address out of delivery area',

  DELIVERY_ADDRESS_BOOK_DELETE_ADDRESS_CLICKED: 'Delete address clicked',
  DELIVERY_ADDRESS_BOOK_DELETE_ADDRESS_POPUP_CONFIRM: 'Delete address pop up - confirm',
  DELIVERY_ADDRESS_BOOK_DELETE_ADDRESS_POPUP_CLOSE: 'Delete address pop up - close',

  STORED_PAYMENT_DETAILS_DELETE_PAYMENT_SUCCESS_NOTIFICATION: 'Delete payment success notification',
  STORED_PAYMENT_DETAILS_DELETE_PAYMENT_ERROR_NOTIFICATION: 'Delete payment error notification',

  STORED_PAYMENT_DETAILS_ADD_NEW_PAYMENT_METHOD_CLICKED: 'Add new payment method clicked',
  STORED_PAYMENT_DETAILS_DELETE_PAYMENT_CLICKED: 'Delete payment method clicked',
  STORED_PAYMENT_DETAILS_DELETE_PAYMENT_POPUP_CONFIRM: 'Delete payment method pop up - confirm',
  STORED_PAYMENT_DETAILS_DELETE_PAYMENT_POPUP_CLOSE: 'Delete payment method pop up - close',
  STORED_PAYMENT_DETAILS_REPLACE_CARD_CLICKED: 'Replace card clicked',

  STORED_PAYMENT_DETAILS_CHANGE_DEFAULT_PAYMENT_METHOD_CLICKED: 'Change default payment methods clicked',
  STORED_PAYMENT_DETAILS_CHANGE_DEFAULT_PAYMENT_METHOD_POPUP_CONFIRM: 'Change default payment method  pop up - confirm',
  STORED_PAYMENT_DETAILS_SUCCESS_NOTIFICATION_DISPLAYED_AFTER_SAVING_PAYMENT_DETAILS: 'Success notification displayed after saving payment details',
  STORED_PAYMENT_DETAILS_ERROR_NOTIFICATION_DISPLAYED_AFTER_SAVING_PAYMENT_DETAILS: 'Error notification displayed after saving payment details',

  STORED_PAYMENT_DETAILS_SUCCESS_NOTIFICATION_DISPLAYED_AFTER_USAGE_ADDITION: 'Success notification displayed after usage addition',
  STORED_PAYMENT_DETAILS_ERROR_NOTIFICATION_DISPLAYED_AFTER_USAGE_ADDITION: 'Error notification displayed after usage addition',

  MARKETING_COMMUNICATIONS_CUSTOMER_CHANGED_CONSENTS: 'Customer changed marketing communications',
  MARKETING_COMMUNICATIONS_SAVE_BUTTON_CLICKED: 'Save button clicked',
  MARKETING_COMMUNICATIONS_SUCCESS_NOTIFICATION_DISPLAYED_AFTER_SAVING: 'Success notification displayed after saving marketing communications',
  MARKETING_COMMUNICATIONS_ERROR_NOTIFICATION_DISPLAYED_AFTER_SAVING: 'Error notification displayed after saving marketing communications',
  MARKETING_COMMUNICATIONS_PRIVACY_POLICY_LINK_CLICKED: 'Customer clicked Privacy & Cookie Policy link',
  MARKETING_COMMUNICATIONS_TERMS_AND_CONDITIONS_LINK_CLICKED: 'Customer clicked Terms & Conditions link',
};

export {
  pageStatistics,
  pageEvents,
};
